import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pagination: JSON.parse(sessionStorage.getItem("pagination") || "{}") || undefined,
}

const pagination = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setPagination: (state, action) => {
        const key = action.payload.key;
        const value = action.payload.value;
        state.pagination = { ...state.pagination, [key]: value };
        sessionStorage.setItem("pagination", JSON.stringify(state.pagination));
    },

    resetAllPagination: (state) => {
      state.pagination = undefined;
      sessionStorage.removeItem("pagination");
    },
   
  },
});

export const { setPagination, resetAllPagination } = pagination.actions;
export default pagination.reducer;